import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import profile from "../../../images/profileAvatar.jpg";

function TecnicosCard({ tecnico }) {
    const [hasImageError, setHasImageError] = useState(false);
    const imageUrl = tecnico.imageUrl;
    const nacionalidadLabel = tecnico.nacionalidad || tecnico.rol;
    const campeonCount = Number(tecnico.campeonCount || 0);
    const campeonLabel = campeonCount > 1 ? `Campeón x${campeonCount}` : "Campeón";

    useEffect(() => {
        setHasImageError(false);
    }, [imageUrl, tecnico.nombre]);

    const imgElement = !hasImageError ? (
        <img
            src={imageUrl}
            alt={tecnico.nombre}
            loading="lazy"
            onError={() => {
                setHasImageError(true);
            }}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
    ) : (
        <img
            src={profile}
            alt={tecnico.nombre}
            loading="lazy"
            className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
        />
    );

    return (
        <Link
            to={`/jugador/${tecnico.nombre}?tipo=tecnico`}
            className="group block rounded-xl border border-white/10 bg-[#102216] overflow-hidden hover:border-green-500 transition-all hover:shadow-xl hover:shadow-green-500/10"
        >
            {/* Mobile: horizontal layout */}
            <div className="flex cellphone:hidden">
                <div className="w-28 shrink-0 relative overflow-hidden bg-[#0b1f13]">
                    {imgElement}
                </div>
                <div className="flex flex-col justify-between flex-1 min-w-0">
                    <div className="p-3">
                        <p className="text-white text-base font-black uppercase leading-tight tracking-tight truncate">
                            {tecnico.nombre}
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                            <span className="text-slate-300 text-xs font-semibold uppercase tracking-wide">
                                {nacionalidadLabel}
                            </span>
                            <span className="text-red-400 text-xs font-black italic">
                                DT
                            </span>
                        </div>
                        {tecnico.isCampeon ? (
                            <span className="inline-block mt-2 rounded-md bg-yellow-300 px-2 py-0.5 text-[10px] font-black text-[#2d2211] uppercase tracking-wide">
                                {campeonLabel}
                            </span>
                        ) : null}
                    </div>
                    <div className="px-3 py-2 bg-[#0b1f13] flex items-center justify-between">
                        <span className="text-sm font-bold text-white">Ver perfil</span>
                        <span className="text-green-500 transition-transform group-hover:translate-x-1" aria-hidden="true">→</span>
                    </div>
                </div>
            </div>

            {/* Desktop: vertical card layout */}
            <div className="hidden cellphone:block">
                <div className="aspect-[4/5] relative overflow-hidden bg-[#0b1f13]">
                    <div className="absolute top-2 left-2 sm:top-3 sm:left-3 z-10 rounded-md bg-red-700 px-1.5 py-0.5 sm:px-2.5 sm:py-1 text-[10px] sm:text-xs font-black text-white italic">
                        DT
                    </div>

                    {tecnico.isCampeon ? (
                        <div className="absolute top-2 right-2 sm:top-3 sm:right-3 z-10 rounded-md bg-yellow-300 px-1.5 py-0.5 sm:px-2.5 sm:py-1 text-[10px] sm:text-xs font-black text-[#2d2211] uppercase tracking-wide">
                            {campeonLabel}
                        </div>
                    ) : null}

                    {imgElement}

                    <div className="absolute inset-0 bg-gradient-to-t from-[#062a1a] via-transparent to-transparent" />

                    <div className="absolute bottom-0 left-0 right-0 p-2 sm:p-4">
                        <p className="text-white text-sm sm:text-lg font-black uppercase leading-tight tracking-tight">
                            {tecnico.nombre}
                        </p>
                        <p className="text-slate-300 text-[10px] sm:text-xs font-semibold uppercase tracking-wide mt-0.5 sm:mt-1">
                            {nacionalidadLabel}
                        </p>
                    </div>
                </div>

                <div className="px-3 py-2 sm:px-4 sm:py-3 bg-[#0b1f13] flex items-center justify-between">
                    <span className="text-sm font-bold text-white">Ver perfil</span>
                    <span className="text-green-500 transition-transform group-hover:translate-x-1" aria-hidden="true">→</span>
                </div>
            </div>
        </Link>
    );
}

export default TecnicosCard;
